module.exports = __webpack_public_path__ + "img/tracking-categories-no-selection.1548197e.svg";